// ==================== src/api/system/email.ts ====================
// 对应后端：system.auth.controller.EmailController
// 请求前缀：/auth/email
import { post } from '@/utils/HttpUtils';

export interface SendEmailCodeParams {
  email: string;
  nickName: string;
  behavior: string;
  view: string;
}

export interface EmailBindParams {
  email: string;
  code: string;
}

export const systemEmailApi = {
  /** 发送邮箱验证码 */
  sendCode: (data: SendEmailCodeParams) =>
    post('/auth/email/code', data),

  /** 绑定邮箱 */
  bindEmail: (data: EmailBindParams) =>
    post('/auth/email/bind', data),

  /** 解绑邮箱 */
  unbindEmail: () =>
    post('/auth/email/unbind'),
};